/* Rebuilt PDP gallery.
 * One Slick carousel at all breakpoints, synced desktop thumbnails,
 * variant media groups resolved client-side from #variant-media-map
 * (Variant Automator convention), fancybox enlarge, video/external
 * video/3D model slides. Depends on jQuery + Slick (bundled in theme.js).
 */
(function () {
  "use strict";

  function escapeHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function Gallery(root) {
    var self = this;
    this.root = root;
    this.productId = root.getAttribute("data-product-id");
    this.$main = window.jQuery(root).find("[data-gallery-main]");
    this.$thumbs = window.jQuery(root).find(".thumbnail-slider");

    var photos = root.closest(".product-photos");
    var config = {};
    try {
      config = JSON.parse((photos && photos.dataset.galleryConfig) || "{}");
    } catch (e) { /* keep defaults */ }
    this.config = config;

    var mapEl = root.parentElement.querySelector("[data-variant-media-map]") ||
      document.getElementById("variant-media-map");
    this.map = null;
    if (mapEl) {
      try { this.map = JSON.parse(mapEl.textContent); } catch (e) { this.map = null; }
    }

    this.mediaById = {};
    this.assignedPositions = {};
    if (this.map) {
      this.map.media.forEach(function (m) { self.mediaById[m.id] = m; });
      Object.keys(this.map.variants).forEach(function (vid) {
        var fid = self.map.variants[vid].featuredMediaId;
        if (fid != null && self.mediaById[fid]) {
          self.assignedPositions[self.mediaById[fid].position] = true;
        }
      });
    }

    this.currentKey = this.groupKeyFromDom();
    this.initCarousels();
    this.bindEvents();
  }

  /* ---- group resolution (mirrors the Liquid logic) ---- */

  Gallery.prototype.groupFor = function (variantId) {
    var map = this.map;
    if (!map) return null;
    var v = map.variants[String(variantId)];
    if (!v) return map.media.slice();
    if (v.galleryIds && v.galleryIds.length && map.files) {
      var files = v.galleryIds.map(function (id) { return map.files[id]; }).filter(Boolean);
      if (files.length) return files;
    }
    if (v.gallery && v.gallery.length) return v.gallery.slice(); // legacy inline format
    var featured = v.featuredMediaId != null ? this.mediaById[v.featuredMediaId] : null;
    if (!featured) return map.media.slice();
    var out = [];
    var inGroup = false;
    for (var i = 0; i < map.media.length; i++) {
      var m = map.media[i];
      if (m.position === featured.position) {
        inGroup = true;
      } else if (inGroup && this.assignedPositions[m.position]) {
        break;
      }
      if (inGroup) out.push(m);
      // sparse assignments let native groups bleed into the next device's
      // unassigned renders — cap the run (curated metafield galleries are exact)
      if (out.length >= 8) break;
    }
    return out.length ? out : map.media.slice();
  };

  function groupKey(group) {
    return group.map(function (m) { return m.id != null ? m.id : (m.src || (m.sources && m.sources[0] && m.sources[0].url) || ""); }).join("|");
  }

  Gallery.prototype.groupKeyFromDom = function () {
    var ids = [];
    this.root.querySelectorAll(".product-slide").forEach(function (el) {
      ids.push(el.getAttribute("data-media-id"));
    });
    return ids.join("|");
  };

  /* ---- rendering ---- */

  Gallery.prototype.slideHtml = function (m, index) {
    var alt = escapeHtml(m.alt);
    var inner;
    if (m.type === "video") {
      inner =
        '<video controls playsinline preload="none" poster="' + escapeHtml(m.poster) + '">' +
        (m.sources || []).map(function (s) {
          return '<source src="' + escapeHtml(s.url) + '" type="' + escapeHtml(s.mime) + '">';
        }).join("") +
        "</video>";
    } else if (m.type === "external_video") {
      inner =
        '<div class="gallery-external-video" data-host="' + escapeHtml(m.host) + '" data-external-id="' + escapeHtml(m.externalId) + '">' +
        '<img class="product__image" src="' + escapeHtml(m.poster) + '" alt="' + alt + '" loading="lazy">' +
        '<button class="gallery-play" type="button" aria-label="Play video"></button></div>';
    } else if (m.type === "model") {
      inner =
        '<div class="gallery-model" data-model-sources=\'' + JSON.stringify(m.sources || []).replace(/'/g, "&#39;") + "'>" +
        '<img class="product__image" src="' + escapeHtml(m.poster) + '" alt="' + alt + '" loading="lazy">' +
        '<button class="gallery-play gallery-model-load" type="button" aria-label="View in 3D"></button></div>';
    } else {
      var dims = (m.width ? ' width="' + m.width + '" height="' + m.height + '"' : "");
      inner =
        '<a class="gallery-enlarge" data-gallery-zoom href="' + escapeHtml(m.zoom || m.src) + '">' +
        '<img class="product__image" src="' + escapeHtml(m.src) + '"' +
        (m.srcset ? ' srcset="' + escapeHtml(m.srcset) + '"' : "") +
        ' sizes="(max-width: 740px) 100vw, 50vw"' + dims +
        ' alt="' + alt + '"' + (index === 0 ? "" : ' loading="lazy"') + ">" +
        "</a>";
    }
    return '<div class="product-slide" data-media-id="' + escapeHtml(m.id != null ? m.id : "mf-" + index) + '" data-type="' + escapeHtml(m.type || "image") + '">' + inner + "</div>";
  };

  Gallery.prototype.thumbHtml = function (m, index) {
    var play = (m.type === "video" || m.type === "external_video") ? '<span class="thumb-play" aria-hidden="true"></span>' : "";
    return '<div class="product-thumbnail' + (index === 0 ? " selected" : "") + '" data-slide-index="' + index + '">' +
      '<img src="' + escapeHtml(m.thumb) + '" loading="lazy" width="150" height="150" alt="' + escapeHtml(m.alt) + '">' + play + "</div>";
  };

  /* ---- carousels ---- */

  Gallery.prototype.initCarousels = function () {
    var $ = window.jQuery;
    var self = this;
    var arrows = this.config.sliderControls !== "dots";

    if (!this.$main.hasClass("slick-initialized")) {
      this.$main.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        // Square-locked slide box (see product-gallery.liquid), so the
        // carousel must NOT resize per slide — adaptiveHeight is what let
        // a single portrait image make the whole gallery taller.
        adaptiveHeight: false,
        arrows: arrows,
        dots: !arrows,
        nextArrow: '<a class="slick-next slick-arrow" aria-label="Next image"><i class="la la-angle-right" aria-hidden="true"></i></a>',
        prevArrow: '<a class="slick-prev slick-arrow" aria-label="Previous image"><i class="la la-angle-left" aria-hidden="true"></i></a>'
      });
    }

    var thumbCount = Math.min(4, parseInt(this.config.thumbnailLimit, 10) || 4);
    if (this.$thumbs.length && !this.$thumbs.hasClass("slick-initialized")) {
      this.$thumbs.slick({
        infinite: false,
        slidesToShow: thumbCount,
        slidesToScroll: thumbCount,
        swipeToSlide: true,
        touchThreshold: 12,
        arrows: true,
        dots: false,
        nextArrow: '<a class="slick-next slick-arrow" aria-label="Next thumbnails"><i class="la la-angle-right" aria-hidden="true"></i></a>',
        prevArrow: '<a class="slick-prev slick-arrow" aria-label="Previous thumbnails"><i class="la la-angle-left" aria-hidden="true"></i></a>'
      });
    }

    this.$main.off("afterChange.pg").on("afterChange.pg", function (e, slick, index) {
      self.onSlideChange(index);
    });

    // adaptiveHeight measures slides before lazy images finish loading, which
    // clips the image bottom; re-measure whenever a gallery image loads.
    var remeasure = function () {
      clearTimeout(self._measureTimer);
      self._measureTimer = setTimeout(function () {
        if (self.$main.hasClass("slick-initialized")) self.$main.slick("setPosition");
      }, 60);
    };
    if (!this._loadListener) {
      this._loadListener = remeasure;
      // capture phase: img load events don't bubble
      this.root.addEventListener("load", remeasure, true);
      $(window).one("load", remeasure);
    }
  };

  Gallery.prototype.onSlideChange = function (index) {
    var self = this;
    // pause playing media on non-active slides
    this.root.querySelectorAll("video").forEach(function (v) { v.pause(); });
    this.root.querySelectorAll(".gallery-external-video iframe").forEach(function (f) {
      var wrap = f.parentElement;
      var slide = wrap.closest(".slick-slide");
      if (!slide || !slide.classList.contains("slick-current")) {
        self.resetExternalVideo(wrap);
      }
    });
    // sync thumbnail selection
    var thumbs = this.root.querySelectorAll(".product-thumbnail");
    thumbs.forEach(function (t) {
      t.classList.toggle("selected", parseInt(t.getAttribute("data-slide-index"), 10) === index);
    });
    if (this.$thumbs.hasClass("slick-initialized")) {
      this.$thumbs.slick("slickGoTo", index);
    }
  };

  Gallery.prototype.resetExternalVideo = function (wrap) {
    var host = wrap.getAttribute("data-host");
    var id = wrap.getAttribute("data-external-id");
    var iframe = wrap.querySelector("iframe");
    if (iframe) iframe.remove();
    var img = wrap.querySelector("img");
    if (img) img.style.display = "";
    var btn = wrap.querySelector(".gallery-play");
    if (btn) btn.style.display = "";
    void host; void id;
  };

  Gallery.prototype.playExternalVideo = function (wrap) {
    var host = wrap.getAttribute("data-host");
    var id = wrap.getAttribute("data-external-id");
    var src = "";
    if (host === "youtube") {
      src = "https://www.youtube.com/embed/" + encodeURIComponent(id) + "?autoplay=1&playsinline=1";
    } else if (host === "vimeo") {
      src = "https://player.vimeo.com/video/" + encodeURIComponent(id) + "?autoplay=1";
    } else {
      return;
    }
    var iframe = document.createElement("iframe");
    iframe.src = src;
    iframe.allow = "autoplay; fullscreen; picture-in-picture";
    iframe.setAttribute("allowfullscreen", "");
    var img = wrap.querySelector("img");
    if (img) img.style.display = "none";
    var btn = wrap.querySelector(".gallery-play");
    if (btn) btn.style.display = "none";
    wrap.appendChild(iframe);
  };

  Gallery.prototype.loadModel = function (wrap) {
    var sources = [];
    try { sources = JSON.parse(wrap.getAttribute("data-model-sources") || "[]"); } catch (e) { /* noop */ }
    var glb = sources.filter(function (s) { return /model\/gltf-binary|\.glb/.test((s.mime || "") + (s.url || "")); })[0] || sources[0];
    if (!glb) return;
    function insert() {
      var mv = document.createElement("model-viewer");
      mv.setAttribute("src", glb.url);
      mv.setAttribute("camera-controls", "");
      mv.setAttribute("auto-rotate", "");
      mv.style.width = "100%";
      mv.style.height = "100%";
      mv.style.minHeight = "300px";
      wrap.innerHTML = "";
      wrap.appendChild(mv);
    }
    if (window.customElements && window.customElements.get("model-viewer")) {
      insert();
    } else {
      var s = document.createElement("script");
      s.type = "module";
      s.src = "https://cdn.shopify.com/shopifycloud/model-viewer/model-viewer.js";
      s.onload = insert;
      document.head.appendChild(s);
    }
  };

  /* ---- events ---- */

  Gallery.prototype.bindEvents = function () {
    var $ = window.jQuery;
    var self = this;

    // thumbnail click -> go to slide
    $(this.root).on("click.pg", ".product-thumbnail", function () {
      var index = parseInt(this.getAttribute("data-slide-index"), 10);
      if (!isNaN(index)) self.$main.slick("slickGoTo", index);
    });

    // play buttons
    $(this.root).on("click.pg", ".gallery-play:not(.gallery-model-load)", function () {
      self.playExternalVideo(this.closest(".gallery-external-video"));
    });
    $(this.root).on("click.pg", ".gallery-model-load", function () {
      self.loadModel(this.closest(".gallery-model"));
    });

    // enlarge via fancybox (images), honoring click_to_enlarge
    var enlarge = this.config.clickToEnlarge !== false;
    if (enlarge && $.fn.fancybox) {
      $(this.root).on("click.pg", "[data-gallery-zoom]", function (e) {
        e.preventDefault();
        var items = [];
        var startIndex = 0;
        var anchors = self.root.querySelectorAll("[data-gallery-zoom]");
        anchors.forEach(function (a, i) {
          items.push({ src: a.getAttribute("href"), type: "image" });
          if (a === e.currentTarget) startIndex = i;
        });
        $.fancybox.open(items, { loop: true }, startIndex);
      });
    } else {
      $(this.root).on("click.pg", "[data-gallery-zoom]", function (e) { e.preventDefault(); });
    }

    // variant change (dispatched from theme.js)
    this._onVariantChange = function (e) {
      var d = e.detail || {};
      if (String(d.productId) !== String(self.productId)) return;
      self.update(d.variantId);
    };
    document.addEventListener("variantchange:media", this._onVariantChange);

    // Case type chosen but no device yet: preview the first available
    // device's media group for that case type without selecting a device.
    // (No full variant resolves in that state, so variantchange:media
    // never fires and the gallery would otherwise sit on stale images.)
    var pjEl = document.getElementById("product-json");
    var pj = null;
    try { pj = pjEl ? JSON.parse(pjEl.textContent) : null; } catch (err) { /* noop */ }
    if (pj && pj.variants && String(pj.id) === String(this.productId)) {
      $(document).on("change.pg" + this.productId, 'select[id="product-select-' + this.productId + '-option-0"]', function () {
        var caseType = this.value;
        var devSel = document.getElementById("product-select-" + self.productId + "-option-1");
        if (devSel && devSel.value && !/select/i.test(devSel.value)) return; // device chosen: normal flow handles it
        var match = null;
        for (var i = 0; i < pj.variants.length; i++) {
          var v = pj.variants[i];
          if (v.option1 === caseType && v.available) { match = v; break; }
        }
        if (!match) {
          for (i = 0; i < pj.variants.length; i++) {
            if (pj.variants[i].option1 === caseType) { match = pj.variants[i]; break; }
          }
        }
        if (match) self.update(match.id);
      });
    }
  };

  /* ---- variant switch ---- */

  Gallery.prototype.update = function (variantId) {
    var group = this.groupFor(variantId);
    if (!group || !group.length) return;
    var key = groupKey(group);
    if (key === this.currentKey) {
      // same media set (e.g. Case Type switch or sibling device sharing renders):
      // no rebuild, but still snap back to the variant's featured slide
      if (this.$main.hasClass("slick-initialized")) this.$main.slick("slickGoTo", 0);
      return;
    }
    this.currentKey = key;

    var self = this;
    var slides = group.map(function (m, i) { return self.slideHtml(m, i); }).join("");
    var thumbs = group.map(function (m, i) { return self.thumbHtml(m, i); }).join("");

    if (this.$main.hasClass("slick-initialized")) this.$main.slick("unslick");
    this.$main.html(slides);
    if (this.$thumbs.hasClass("slick-initialized")) this.$thumbs.slick("unslick");
    this.$thumbs.html(thumbs);
    this.initCarousels();
    this.$main.slick("slickGoTo", 0, true);
  };

  /* ---- bootstrapping ---- */

  function initAll(scope) {
    (scope || document).querySelectorAll("[data-product-gallery]").forEach(function (root) {
      if (root.__pgInit) return;
      root.__pgInit = true;
      new Gallery(root);
    });
  }

  function boot() {
    if (!window.jQuery || !window.jQuery.fn.slick) {
      // theme.js (which bundles Slick) is deferred; retry shortly
      return void setTimeout(boot, 50);
    }
    initAll(document);
    if (window.Events && window.Events.on) {
      window.Events.on("quickview:load", function (context) { initAll(context || document); });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
